/**
 * Lo que esta pantalla necesita y NO es una regla.
 *
 * 🔴 Las reglas —los cuatro supuestos, los modos, los campos y los invariantes—
 * viven en `@claimup/shared/constants/whatsapp-dispatch`, que leen los dos
 * lados. Aquí solo queda lo que es puramente de presentación: cómo se llaman los
 * canales en pantalla, las letras de los días, los idiomas del desplegable.
 *
 * La primera versión de este fichero llevaba su propia copia de los supuestos y
 * de la lista de campos, y eso era exactamente el fallo que este rediseño viene
 * a cerrar: dos listas de lo mismo en dos sitios acaban discrepando, y gana la
 * que nadie mira. Es lo que pasó con `PROTECTED_STATES`.
 */
export {
  SUPUESTOS,
  MODOS,
  CAMPOS,
  NOMBRES_DE_CAMPO,
  INVARIANTES,
} from '@claimup/shared/constants/whatsapp-dispatch';

/** Cómo se llaman los canales para una persona. */
export const CANALES = [
  { id: 'navegador', nombre: 'Navegador', detalle: 'Chrome real en el portátil' },
  { id: 'maytapi', nombre: 'Maytapi', detalle: 'API' },
];

/** Los días, en el orden en que se leen y con el índice que usa JavaScript. */
export const DIAS = [
  { id: 1, nombre: 'L' },
  { id: 2, nombre: 'M' },
  { id: 3, nombre: 'X' },
  { id: 4, nombre: 'J' },
  { id: 5, nombre: 'V' },
  { id: 6, nombre: 'S' },
  { id: 0, nombre: 'D' },
];

export const PAISES = [
  { id: 'ES', nombre: 'España' },
  { id: 'US', nombre: 'Estados Unidos' },
];

export const IDIOMAS = [
  { id: 'es', nombre: 'Español' },
  { id: 'en', nombre: 'Inglés' },
];

export const TIPOS_DE_TAREA = [
  { id: 'new_whatsapp', nombre: 'WhatsApp inicial' },
  { id: 'follow_up_whatsapp', nombre: 'WhatsApp de seguimiento' },
  { id: 'reply_whatsapp', nombre: 'Responder WhatsApp' },
];

/**
 * Lo que la pantalla asume si el backend todavía no manda un campo.
 *
 * No son «los valores buenos»: son lo que evita que un control aparezca vacío
 * mientras se despliega. Los de verdad los manda el backend en `efectiva`.
 */
export const SI_FALTA = {
  entrada: {
    solo_del_agente: true,
    tipos: TIPOS_DE_TAREA.map((t) => t.id),
    caducidad_sello_horas: 24,
    reintento_min: 15,
    tope_candidatas: 500,
    tareas_por_pasada: 40,
  },
  ventana: { dias: [1, 2, 3, 4, 5], inicio: 9, fin: 20, zona: 'Europe/Madrid' },
  estados_urgentes: [],
  supuestos: {},
  orden_de_clientes: [],
  clientes_aparcados: [],
  estados_fuera_del_frio: [],
  paises_permitidos: PAISES.map((p) => p.id),
  orden_de_canales: CANALES.map((c) => c.id),
  idioma_por_cliente: {},
  idioma_por_defecto: 'es',
  canales: {},
  lineas: [],
};
